export default __webpack_public_path__ + "locales/en/Common.json?hash=94d58d150660cedca60d0c7d9f1a0268";